import { useQuery } from 'react-query';
import { network } from 'services/network';

import { QueryKeys } from 'api/queryKeys';

const queryFn = (params: Omit<QueryParams, 'runQsra'>): Promise<QueryFnResponse> => {
    return network.post('api/bo/getSummaryKpi', params).then((response) => {
        return response.data;
    });
};

export const useQueryGetSummaryKpi = (params: QueryParams) => {
    const { runQsra, ...payload } = params;
    return useQuery<QueryFnResponse, QueryError, QueryResponse | null, [QueryKeys, unknown]>({
        queryKey: ['getSummaryKpi', params],
        queryFn: () => queryFn(payload),
        enabled: Boolean(params.runQsra) && Boolean(params.taskVersionHashCode) && Boolean(params.metaDataId),
        select: (response) => {
            return response.deterministic &&
                response.activity &&
                response.conservative &&
                response.realistic &&
                response.aggressive
                ? {
                      activity: response.activity,
                      deterministic: response.deterministic,
                      aggressive: response.aggressive,
                      realistic: response.realistic,
                      conservative: response.conservative,
                  }
                : null;
        },
    });
};

interface QueryParams {
    metaDataId: number;
    numOfIterations: number;
    riskIds: number[];
    taskVersionHashCode: string | null;
    runQsra: number | null;
    period: string;
}

interface QueryFnResponse {
    activity: {
        name: string;
        activityId: string;
        taskId: number;
    } | null;
    deterministic: {
        dateVariance: number;
        name: string;
        pDate: number;
        pValue: number;
        userDefined: { baselineFinish: number };
    } | null;
    aggressive: {
        name: string;
        pValue: number;
        pDate: number;
        dateVariance: number;
    } | null;
    realistic: {
        name: string;
        pValue: number;
        pDate: number;
        dateVariance: number;
    } | null;
    conservative: {
        name: string;
        pValue: number;
        pDate: number;
        dateVariance: number;
    } | null;
}

// export type QueryResponse = QueryFnResponse | null;

export type QueryResponse = {
    activity: {
        name: string;
        activityId: string;
        taskId: number;
    };
    deterministic: {
        dateVariance: number;
        name: string;
        pDate: number;
        pValue: number;
        userDefined: { baselineFinish: number };
    };
    aggressive: {
        name: string;
        pValue: number;
        pDate: number;
        dateVariance: number;
    };
    realistic: {
        name: string;
        pValue: number;
        pDate: number;
        dateVariance: number;
    };
    conservative: {
        name: string;
        pValue: number;
        pDate: number;
        dateVariance: number;
    };
} | null;
